import { use, useMemo, useState } from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import { useSearchParams } from 'next/navigation';
import { refetchHomePageRecommendationsForBuyer } from '../../actions';
import { CreateWishlistDialog } from '../../wishlist/_components/CreateWishlistDialog';
import { WishlistsWithMetadata } from '../../wishlist/types';
import { FlatBuyerPreferences } from '../types';

type Props = ButtonProps & {
  categoriesPromise: Promise<{ [key: string]: string[] }>;
  preferencesPromise: Promise<FlatBuyerPreferences>;
  wishlistsPromise: Promise<WishlistsWithMetadata>;
};

export const AddToWishlistButton = ({
  categoriesPromise,
  preferencesPromise,
  wishlistsPromise,
  ...rest
}: Props) => {
  const searchParams = useSearchParams();
  const shouldOpenWishlistDialog = searchParams.get('open-wishlist-dialog') === 'true';
  const { wishlists } = use(wishlistsPromise);
  const wishlistBrands = useMemo(() => wishlists.map((wishlist) => wishlist.brand), [wishlists]);
  const [isCreateWishlistDialogOpen, setIsCreateWishlistDialogOpen] =
    useState(shouldOpenWishlistDialog);

  const handleDialogOpen = () => setIsCreateWishlistDialogOpen(true);
  const handleDialogClose = (success?: boolean) => {
    if (success) {
      // Refresh listings
      refetchHomePageRecommendationsForBuyer();
    }
    setIsCreateWishlistDialogOpen(false);
  };

  return (
    <>
      <Button color="buttonBrandPrimary" {...rest} onClick={handleDialogOpen}>
        Add to Wishlist
      </Button>
      <CreateWishlistDialog
        currentWishlists={wishlistBrands}
        isOpen={isCreateWishlistDialogOpen}
        handleClose={handleDialogClose}
        categoriesPromise={categoriesPromise}
        preferencesPromise={preferencesPromise}
      />
    </>
  );
};
